<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações Gerais de Finanças</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Gerencie as definições padrão de pagamentos, recebimentos e layouts financeiros.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="250" marginTop="0"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
        <div class="row mt-3">
          <div class="col-12 col-md-4">
            <app-loading-box height="56" width="100%"></app-loading-box>
          </div>
          <div class="col-12 col-md-4">
            <app-loading-box height="56" width="100%"></app-loading-box>
          </div>
          <div class="col-12 col-md-4">
            <app-loading-box height="56" width="100%"></app-loading-box>
          </div>
        </div>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="300" marginTop="0"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="12"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="260" marginTop="0"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="section-container">
          <div class="section-title">
            <mat-icon>swap_horiz</mat-icon>
            <span>Estornos e Padrões de Operação</span>
          </div>

          <div class="row mt-3">
            <div class="col-12 mb-3">
              <label class="font-weight-bold d-block mb-2">Estorno de Contas</label>
              <mat-radio-group
                formControlName="idTipoEstornoConta"
                class="d-flex flex-wrap"
                style="gap: 15px">
                @for (item of opcoesTipoEstornoConta; track item.idTipoEstornoConta) {
                  <mat-radio-button [value]="item.idTipoEstornoConta">{{ item.descricao }}</mat-radio-button>
                }
              </mat-radio-group>
              <div class="hint-text mt-2">Ao excluir a NF, o estorno também será automático.</div>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Forma de Pagamento Padrão</mat-label>
                <mat-select formControlName="idFormaPagamento">
                  <mat-option [value]="null">Selecione uma opção</mat-option>
                  @for (item of opcoesFormaPagamento; track item.idFormaPagamento) {
                    <mat-option [value]="item.idFormaPagamento">{{ item.descricao }}</mat-option>
                  }
                </mat-select>
                @if (form.get('idFormaPagamento')?.hasError('required')) {
                  <mat-error>Obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Forma de Recebimento Padrão</mat-label>
                <mat-select formControlName="idFormaRecebimento">
                  <mat-option [value]="null">Selecione uma opção</mat-option>
                  @for (item of opcoesFormaRecebimento; track item.id) {
                    <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
                  }
                </mat-select>
                @if (form.get('idFormaRecebimento')?.hasError('required')) {
                  <mat-error>Obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Data de Recebimento Padrão</mat-label>
                <mat-select formControlName="idTipoDataRecebimentoPadrao">
                  @for (item of opcoesTipoDataRecebimentoPadrao; track item.idTipoDataRecebimentoPadrao) {
                    <mat-option [value]="item.idTipoDataRecebimentoPadrao">{{ item.descricao }}</mat-option>
                  }
                </mat-select>
                @if (form.get('idTipoDataRecebimentoPadrao')?.hasError('required')) {
                  <mat-error>Obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="section-container mt-4">
          <div class="section-title">
            <mat-icon>account_balance</mat-icon>
            <span>Baixa de Títulos e Conciliação Bancária</span>
          </div>

          <div class="row mt-3">
            <div class="col-12 mb-3">
              <label class="font-weight-bold d-block mb-2">Baixa de Títulos (Retorno Bancário)</label>
              <mat-radio-group formControlName="idTipoBaixaTitulo" class="d-flex flex-wrap" style="gap: 15px">
                @for (item of opcoesTipoBaixaTitulo; track item.idTipoBaixaTitulo) {
                  <mat-radio-button [value]="item.idTipoBaixaTitulo">{{ item.descricao }}</mat-radio-button>
                }
              </mat-radio-group>
            </div>

            @if (form.get('idTipoBaixaTitulo')?.value === tipoBaixaTituloEnum.Individual) {
              <div class="col-12 mb-3 mt-2">
                <mat-radio-group
                  formControlName="idTipoCategoriaRetornoBancario"
                  class="d-flex flex-column ml-3"
                  style="gap: 10px">
                  @for (
                    item of opcoesTipoCategoriaRetornoBancario;
                    track item.idTipoCategoriaRetornoBancario
                  ) {
                    <mat-radio-button [value]="item.idTipoCategoriaRetornoBancario">{{
                      item.descricao
                    }}</mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            }
            @if (
              form.get('idTipoBaixaTitulo')?.value === tipoBaixaTituloEnum.Agrupado ||
              (form.get('idTipoBaixaTitulo')?.value === tipoBaixaTituloEnum.Individual &&
                form.get('idTipoCategoriaRetornoBancario')?.value ===
                  tipoCategoriaRetornoBancarioEnum.UsarUmaCategoriaEspecifica)
            ) {
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Categoria padrão de lançamento das liquidações do retorno</mat-label>
                  <mat-select formControlName="idCategoriaFinanceiraLiquidacao">
                    <mat-option [value]="null">Selecione uma categoria</mat-option>
                    @for (item of opcoesCategoriaFinanceira; track item.idCategoriaFinanceira) {
                      <mat-option [value]="item.idCategoriaFinanceira">{{ item.descricao }}</mat-option>
                    }
                  </mat-select>
                  @if (form.get('idCategoriaFinanceiraLiquidacao')?.hasError('required')) {
                    <mat-error>Obrigatório.</mat-error>
                  }
                </mat-form-field>
              </div>
            }

            <div class="col-12 mt-2">
              <mat-slide-toggle
                class="config-toggle app-toggle-compact"
                formControlName="isMarcarCanceladoBaixaBanco"
                color="primary">
                Sempre marcar como cancelado os títulos baixados do banco
              </mat-slide-toggle>
            </div>
          </div>
        </div>

        <div class="section-container mt-4">
          <div class="section-title">
            <mat-icon>receipt_long</mat-icon>
            <span>Boletos e Documentos</span>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <div class="mb-3">
                <mat-slide-toggle
                  class="config-toggle app-toggle-compact"
                  formControlName="isExibirHistoricoLogo"
                  color="primary"
                  (change)="onExibirHistoricoLogoChange($event)">
                  Exibir o histórico e logo na impressão dos boletos
                </mat-slide-toggle>
              </div>
              <div class="mb-3">
                <mat-slide-toggle
                  class="config-toggle app-toggle-compact"
                  formControlName="isEnviarLinhaDigitavel"
                  color="primary">
                  Enviar linha digitável no histórico
                </mat-slide-toggle>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle
                  class="app-toggle-compact"
                  formControlName="isAtualizarVencimentoNf"
                  color="primary">
                  Atualizar datas de vencimento das parcelas ao gerar notas fiscais
                </mat-slide-toggle>
                <span class="info-text">
                  Caso o título alterado tenha vínculo com uma NF-e lançada, a data de vencimento da nota
                  também será atualizada.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="section-container mt-4">
          <div class="section-title">
            <mat-icon>paid</mat-icon>
            <span>Tarifas e Status do Lançamento</span>
          </div>

          <div class="row mt-3">
            <div class="col-12 mb-3">
              <mat-slide-toggle
                class="config-toggle app-toggle-compact"
                formControlName="isLancarTarifasCaixa"
                color="primary">
                Lançar Tarifas no Caixa
              </mat-slide-toggle>
            </div>

            @if (form.get('isLancarTarifasCaixa')?.value) {
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Categoria Financeira vinculada à Tarifa</mat-label>
                  <mat-select formControlName="idCategoriaFinanceiraTarifa">
                    <mat-option [value]="null">Selecione uma categoria</mat-option>
                    @for (item of opcoesCategoriaFinanceira; track item.idCategoriaFinanceira) {
                      <mat-option [value]="item.idCategoriaFinanceira">{{ item.descricao }}</mat-option>
                    }
                  </mat-select>
                  @if (form.get('idCategoriaFinanceiraTarifa')?.hasError('required')) {
                    <mat-error>Obrigatório.</mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
